<template>
<div>
  <div class="row p-t-lg immolisting">
    <div class="col-24 col-md-12 col-lg-14">
      <h1 class="immoapp__intro">{{ $t("Ihr Besichtigungstermin") }}</h1>

      <p>Sie haben einen Termin für {{ time | moment("dddd") }}, {{ time | moment("L") }} um {{ time | moment("hhmm") }}&nbsp;Uhr in {{ expose.city }} verbindlich reserviert.</p>

      <div class="row">
        <div class="col-24 col-md-12 col-lg-11">
          <div class="immoapp__appointmentbox">
              <span class="fal fa-calendar-day"></span>
              <p>{{ time | moment("L") }} <br/> {{ time | moment("hhmm") }}&nbsp;Uhr</p>
          </div>
        </div>
        <div class="col-24 col-md-12 col-lg-13">
          <div class="immoapp__appointmentbox">
              <span class="fal fa-map-marker-alt"></span>
              <p>{{ expose.street }}<br>
                {{ expose.zip }} {{ expose.city }}</p>
          </div>
        </div>
      </div>

      <p>Sie können den vereinbarten Termin nicht wahrnehmen?</p>

      <p>
        <button class="btn btn-primary btn-primary-inverse" @click="remove()">Termin jetzt stornieren</button>
      </p>
    </div>

    <div class="col-24 col-md-12 col-lg-8 offset-lg-2">

      <expose :item="expose" />

    </div>
  </div>

  <confirm v-model="confirm" okButtonText="stornieren">
    <template #default="slotProps">
      Möchten Sie den Termin am {{ slotProps.data.time | moment("L") }}, {{ slotProps.data.time | moment("hhmm") }}<br/>Uhr wirklich stornieren?
    </template>
  </confirm>
</div>
</template>

<script>
import Confirm from "./Confirm.vue";
import Expose from "./Expose";

export default {
  name: "ExposeCalendarAppointment",

  components: {
    Confirm,
    Expose
  },

  data() {
    return {
      date: null, //new Date().toISOString().substr(0, 10),
      pickerDate: null,
      confirm: true
    };
  },

  props: [
    "appointment",
    "expose"
  ],

  computed: {
    time() {
      return this.appointment.start;
    }
  },

  created() {
    this.$store.dispatch("appData", {"title": this.$t("Ihr Besichtigungstermin")});
  },

  methods: {
    remove() {
      this.confirm = {
        title: "Termin stornieren",
        data: {
          time: this.time
        },
        ok: () => {
          this.$store.dispatch("expose/deleteCalendarAppointment", {
            exposeId: this.expose.exposeId,
            uuid: this.appointment.uuid
          }).then(() => {
            this.$store.dispatch("expose/loadCalendar", { exposeId: this.expose.exposeId, force: true });
          });
        }
      };
    }
  }
};
</script>
